import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';

const ProductInfo = ({subscription, className, showNewProduct = true, ...other}) => {
    
    // Use moment lib to determine if the product is a new one i.e. added during last 24 hours
    const yesterday = moment().add(-24, 'hours');
    const contractStartMoment = moment(subscription.contractStartDate, "DD-MM-YYYY");
    const isNewProduct = showNewProduct && moment(contractStartMoment).isAfter(yesterday);
    const mainClasses = classnames('product-info', className, { 'new': isNewProduct });
    
    return (
        <div {...other} className={mainClasses}>
            <div className="title-primary">
                {subscription.name}
            </div>
            <div className="title-secondary">
                (Sn: {subscription.serialNumber||'N/A'})
            </div>
        </div>
    );
};

ProductInfo.propTypes = {
    subscription: PropTypes.object.isRequired
};


export default ProductInfo;